import { render, staticRenderFns } from "./qrcodeMarginController.vue?vue&type=template&id=1fc9f98c&"
import script from "./qrcodeMarginController.vue?vue&type=script&lang=ts&"
export * from "./qrcodeMarginController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports